import React from 'react';
import { BrowserRouter, HashRouter, Routes, Route, useLocation } from 'react-router-dom';
import { Capacitor } from '@capacitor/core';
import { AuthProvider } from './context/AuthContext';
import { StoryProvider } from './context/StoryContext';
import { ThemeProvider } from './context/ThemeContext';
import Navbar from './components/layout/Navbar';
import LandingNavbar from './components/layout/LandingNavbar';
import Footer from './components/layout/Footer';
import Landing from './pages/Landing';
import HowItWorks from './pages/HowItWorks';
import Clips from './pages/Clips';
import Pricing from './pages/Pricing';
import OnboardingQuiz from './pages/setup/OnboardingQuiz';
import WorldSetup from './pages/setup/WorldSetup';
import CharacterSetup from './pages/setup/CharacterSetup';
import AIConfig from './pages/setup/AIConfig';
import StoryView from './pages/StoryView';
import UserSettings from './pages/settings/UserSettings';
import Characters from './pages/settings/Characters';
import Analytics from './pages/Analytics';
import ArchivePage from './pages/ArchivePage';
import Dashboard from './pages/Dashboard';
import AITunePage from './pages/AITunePage';
import AuthPage from './pages/AuthPage';
import UpdatePasswordPage from './pages/UpdatePasswordPage';
import Privacy from './pages/legal/Privacy';
import Terms from './pages/legal/Terms';
import Support from './pages/legal/Support';
import NotificationManager from './components/NotificationManager';
import { useNavigate } from 'react-router-dom';
import { useEffect } from 'react';

// StoryView uses full viewport height — don't show footer there
const AppLayout = () => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const windowHash = window.location.hash;
    if (windowHash && (windowHash.includes('type=invite') || windowHash.includes('type=recovery'))) {
      navigate('/update-password' + windowHash);
    }
  }, [navigate]);
  const hideFooter = location.pathname === '/story';
  const isLanding = location.pathname === '/' || location.pathname === '/how-it-works' || location.pathname === '/clips' || location.pathname === '/pricing' || location.pathname === '/auth';

  return (
    <div className="min-h-[100dvh] flex flex-col bg-white dark:bg-slate-950 font-sans transition-colors duration-300">
      {isLanding ? <LandingNavbar /> : <Navbar />}
      <main className="flex-grow">
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/how-it-works" element={<HowItWorks />} />
          <Route path="/clips" element={<Clips />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/setup/quiz" element={<OnboardingQuiz />} />
          <Route path="/setup/world" element={<WorldSetup />} />
          <Route path="/setup/character" element={<CharacterSetup />} />
          <Route path="/setup/ai" element={<AIConfig />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/story" element={<StoryView />} />
          <Route path="/profile" element={<UserSettings />} />
          <Route path="/characters" element={<Characters />} />
          <Route path="/analytics" element={<Analytics />} />
          <Route path="/archive" element={<ArchivePage />} />
          <Route path="/ai-tune" element={<AITunePage />} />
          <Route path="/auth" element={<AuthPage />} />
          <Route path="/update-password" element={<UpdatePasswordPage />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/support" element={<Support />} />
        </Routes>
      </main>
      {!hideFooter && <Footer />}
      <NotificationManager />
    </div>
  );
};

function App() {
  const isNative = Capacitor.isNativePlatform();
  const Router = isNative ? HashRouter : BrowserRouter;

  return (
    <AuthProvider>
      <ThemeProvider>
        <StoryProvider>
          <Router>
            <AppLayout />
          </Router>
        </StoryProvider>
      </ThemeProvider>
    </AuthProvider>
  );
}

export default App;